module.exports = __webpack_public_path__ + "media/tum-pai-tum-mai.1e50089a.mp3";